import React, {useRef, useState, useEffect} from "react";
import styles from "./InternalInfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'

export default function InternalInfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.app_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.channelName}
        </td>
        <td
            className={styles.td1}
        >{props.item.jifei_guize_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.use_type}
        </td>
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.test}*/}
        {/*</td>*/}
        <td
            className={styles.td1}
        >{props.item.use_num}
        </td>
        <td
            className={styles.td1}
        >{props.item.chengben_jifen}
        </td>
        <td
            className={styles.td1}
        >{props.item.jifen}
        </td>
        <td
            className={styles.td1}
        >{props.item.user_login}
        </td>
        <td
            className={styles.td1}
        >
            {props.item.name}
        </td>
        <td
            className={styles.td1}
        >{props.item.use_time}
        </td>
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.use_ip}*/}
        {/*</td>*/}


        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

